import React from 'react';
import { motion } from "framer-motion";
import arrow from "../assets/images/arrowupdown.png";
import indexImg from "../assets/images/Frame 2.png";

export default function SendMoneyInstntly() {
    return (
        <>
            <section className='px-[10%] py-[3%] bg-[#F5FAFF]'>
                <div className='grid md:grid-cols-12 gap-16'>

                    {/* Left Image */}
                    <motion.div
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: false }}
                        className='lg:col-span-6 p-6'
                    >
                        <div className='pt-10 px-6'>
                            <img src={indexImg} alt="a man" className='w-[100%] pt-8' />
                        </div>
                    </motion.div>

                    {/* Right Text */}
                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        viewport={{ once: false }}
                        className='lg:col-span-6 px-6'
                    >
                        <h1 className='text-[#002455] text-[1.8rem] md:text-[2rem] font-[800] leading-[1] py-6 px-4'>
                            Send Money Instantly, <br /> Securely and Hassle-Free <br /> with
                            <span className='relative text-[var(--second-primary-color)] send_money'> Fastest</span>
                        </h1>
                        <div className='text-[#555D68] text-[.9rem] leading-[2]'>
                            <p className='px-4 py-2'>
                                Transferring money abroad does not have to be slow, risky or complicated. At Fastest,
                                we utilize cutting-edge technology to offer instant, secure and hassle-free global money transfers.
                            </p>

                            <p className='flex px-4 py-2'>
                                <i className="fa-solid fa-lock flex justify-center items-center mr-6 h-[25px] w-[25px] rounded-full bg-[#F5E3EC] text-[14px] text-[var(--second-primary-color)]"></i>
                                <span>Pay online securely with instant notification</span>
                            </p>

                            <p className='flex px-4 py-2'>
                                <i className="flex justify-center items-center mr-6 h-[25px] w-[25px] rounded-full bg-[#D1E3FB]">
                                    <img src={arrow} alt="arrow" className='w-[15px]' />
                                </i>
                                <span>Convert your money in seconds</span>
                            </p>
                        </div>
                    </motion.div>
                </div>
            </section>

            
        </>
    );
}
